"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.triagePageSlugs = exports.topicPageSlugs = exports.productPageSlugs = exports.personSlugs = exports.pageSlugsV2 = exports.pageSlugs = exports.journeySlugs = exports.helpPostSlugs = void 0;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
/**
 * Query builder for product page slugs
 *
 * @param {object} options
 * @param {boolean} options.hasParent - flag to include product pages that have a category
 * @param {boolean} options.hasSubLevel - flag to include product pages that have a subCategory
 * @returns {object} Contentful query
 */
var productPageSlugs = function productPageSlugs(_ref) {
  var _ref$hasParent = _ref.hasParent,
    hasParent = _ref$hasParent === void 0 ? false : _ref$hasParent,
    _ref$hasSubLevel = _ref.hasSubLevel,
    hasSubLevel = _ref$hasSubLevel === void 0 ? false : _ref$hasSubLevel;
  return {
    content_type: 'productPage',
    select: 'fields.slug,fields.category,fields.subCategory',
    'fields.category[exists]': hasParent,
    'fields.subCategory[exists]': hasSubLevel
  };
};

/**
 * Query builder for page slugs
 *
 * @param {object} options
 * @param {boolean} options.hasParent - flag to include pages that have a parent
 * @param {boolean} options.hasSubLevel - flag to include pages that have a subLevel
 * @returns {object} Contentful query
 */
exports.productPageSlugs = productPageSlugs;
var pageSlugs = function pageSlugs(_ref2) {
  var _ref2$hasParent = _ref2.hasParent,
    hasParent = _ref2$hasParent === void 0 ? false : _ref2$hasParent,
    _ref2$hasSubLevel = _ref2.hasSubLevel,
    hasSubLevel = _ref2$hasSubLevel === void 0 ? false : _ref2$hasSubLevel,
    pageTypes = _ref2.pageTypes;
  return _objectSpread({
    content_type: 'page',
    select: 'fields.slug,fields.parent,fields.subLevel',
    'fields.pageType[ne]': 'home',
    'fields.parent[exists]': hasParent,
    'fields.subLevel[exists]': hasSubLevel
  }, pageTypes ? {
    'fields.pageType[in]': pageTypes.join(',')
  } : {});
};

/**
 * Query builder for page slugs (v2)
 *
 * @param {object} options
 * @param {boolean} options.hasParent - flag to include pages that have a parent
 * @param {boolean} options.hasSubLevel - flag to include pages that have a subLevel
 * @returns {object} Contentful query
 */
exports.pageSlugs = pageSlugs;
var pageSlugsV2 = function pageSlugsV2(_ref3) {
  var _ref3$hasParent = _ref3.hasParent,
    hasParent = _ref3$hasParent === void 0 ? false : _ref3$hasParent,
    _ref3$hasSubLevel = _ref3.hasSubLevel,
    hasSubLevel = _ref3$hasSubLevel === void 0 ? false : _ref3$hasSubLevel,
    pageTypes = _ref3.pageTypes;
  return _objectSpread({
    content_type: 'page_v2',
    select: 'fields.slug,fields.parent,fields.subLevel',
    'fields.pageType[ne]': 'home',
    'fields.parent[exists]': hasParent,
    'fields.subLevel[exists]': hasSubLevel
  }, pageTypes ? {
    'fields.pageType[in]': pageTypes.join(',')
  } : {});
};

/**
 * Query builder for person slugs
 * @returns {object} Contentful query
 */
exports.pageSlugsV2 = pageSlugsV2;
var personSlugs = function personSlugs() {
  return {
    content_type: 'person',
    select: 'fields.slug,fields.external',
    'fields.external': false
  };
};

/**
 * Query builder for topic page slugs
 * @param {object} options
 * @param {boolean} options.hasParent - flag to include topics with/without a parent
 * @returns Contentful query
 */
exports.personSlugs = personSlugs;
var topicPageSlugs = function topicPageSlugs() {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref4$hasParent = _ref4.hasParent,
    hasParent = _ref4$hasParent === void 0 ? false : _ref4$hasParent;
  return {
    content_type: 'topicPage',
    select: 'fields.slug,fields.parent',
    'fields.parent[exists]': hasParent
  };
};

/**
 * Query builder for help post slugs
 * @returns Contentful query
 */
exports.topicPageSlugs = topicPageSlugs;
var helpPostSlugs = function helpPostSlugs() {
  return {
    content_type: 'helpPost',
    select: 'fields.slug,fields.topics'
  };
};

/**
 * Query builder for order journey slugs
 * @returns Contentful query
 */
exports.helpPostSlugs = helpPostSlugs;
var journeySlugs = function journeySlugs() {
  return {
    content_type: 'journey',
    select: 'fields.slug'
  };
};

/**
 * Query builder for triage page slugs
 * @returns Contentful query
 */
exports.journeySlugs = journeySlugs;
var triagePageSlugs = function triagePageSlugs() {
  return {
    content_type: 'triagePage',
    select: 'fields.slug'
  };
};
exports.triagePageSlugs = triagePageSlugs;